import { gql } from '@apollo/client/core';

export const GET_PREISMODELLE_BY_STANDORT_ID = gql(`
  query getPreismodelleByStandortId($standortId: String!) {
    vertraegeByIdStandort(standortId: $standortId) {
        id
        preisModell
    }
  }
`);
